module.exports = __webpack_public_path__ + "static/media/techno-7.cf2380f0.png";